// extracted by mini-css-extract-plugin
export default {"menu":"logout_menu__QvOKQ"};